/**
 * Customer portal brand contract.
 *
 * Keep customer-facing identity in one seam so checkout, activation, auth,
 * and the authenticated workspace cannot drift independently.
 */
import { resolveBrand } from '../../../../packages/ui/src/branding/host-brand';

export const PORTAL_BRAND = resolveBrand(typeof window === 'undefined' ? '' : window.location.hostname);

export type PortalBrand = typeof PORTAL_BRAND;
